import React from 'react';
import { IoMdCheckmark } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';

import Button, { ButtonType } from 'legacy/common/components/button/Button';

interface Props {
  type?: ButtonType;
  fillContainer?: boolean;
  isUserPending: boolean;
  isUserAdmin: boolean;
  isUserMember: boolean;
  join: () => void;
  isAssociation?: boolean;
  isJoinBlocked?: boolean;
  blockedMessage?: string;
}

const JoinButton = ({
  type = ButtonType.Primary,
  fillContainer,
  isUserPending,
  isUserMember,
  isUserAdmin,
  join,
  isAssociation,
  isJoinBlocked = false,
  blockedMessage
}: Props) => {
  const { t } = useTranslation(['organizations', 'associations']);
  let buttonText = isAssociation
    ? t('associations:join')
    : t('organizations:actions.join');
  const hasJoined = isUserMember || isUserAdmin;

  if (isUserPending) {
    buttonText = t('organizations:publicView.pendingApproval');
  } else if (hasJoined) {
    buttonText = t('organizations:publicView.joined');
  }

  const isDisabled = hasJoined || isUserPending || isJoinBlocked;
  const tooltipId = `join-button-blocked-tooltip-${
    isAssociation ? 'association' : 'organization'
  }`;

  const button = (
    <Button
      className="!bg-[#3853C4] !text-white !border-none !w-[223px] !h-[48px] !rounded-full tracking-[-0.12px]"
      type={isDisabled ? ButtonType.Secondary : type}
      icon={hasJoined ? <IoMdCheckmark size={20} /> : null}
      newRadius
      fillContainer={fillContainer}
      disabled={isDisabled}
      onClick={join}
    >
      {buttonText}
    </Button>
  );

  if (isJoinBlocked && blockedMessage && !hasJoined && !isUserPending) {
    return (
      <>
        <div data-tip data-for={tooltipId}>
          {button}
        </div>
        <ReactTooltip
          id={tooltipId}
          place="top"
          effect="solid"
          className="!max-w-xs"
        >
          <p>{blockedMessage}</p>
        </ReactTooltip>
      </>
    );
  }

  return button;
};

export default JoinButton;
